// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__340zy","row":"Node_row__3UCEc","label":"Node_label__15PNa","footer":"Node_footer__1vdMI"};